import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let member = useDataValue({
    viewPath: props.viewPath,
    context: 'groupMember',
  })
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'tab',
  })

  return function onClick() {
    submit({
      type: 'scheduling/selectTemplatedSlot',
      id: member.id,
      provider_id: member.provider_id,
      focus: true,
    })
  }
}
